export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./WarningAlert.vue?vue&type=template&id=c8f1f9e0&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Alerts/WarningAlert.vue?vue&type=template&id=c8f1f9e0&scoped=true&
// module id = null
// module chunks = 